import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import {Button,Typography,Grid,CardActions,Card,CardHeader,CardMedia,CardContent,Avatar,IconButton} from '@material-ui/core';
import childAbuse from '../../assets/download.jpg'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStar } from "@fortawesome/free-solid-svg-icons"
import { Link } from 'react-router-dom'
// import './writersblog.css'
import {Helmet} from "react-helmet";
import Loading from '../loading'
import axios from 'axios'
import ShareIcon from '@material-ui/icons/Share';
import icon from '../../assets/favicon.ico'
import { CopyToClipboard } from 'react-copy-to-clipboard';

const styles = theme => ({
    card: {
        maxWidth: 400,
        backgroundColor: 'whitesmoke',
        borderRadius: 10,
    },
    cardContent: {
        paddingBottom: 0,
        textAlign: 'justify'
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
        borderBottomRadius: 10
    },
    image: {
        backgroundImage: { childAbuse }
    }
});

export class WritersBlog extends Component {
    state = {
        articles: [],
        loading: true,
        done: undefined,
        change: true,
        currentPage: 1,
        copied: false,
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
        //all articles
        axios.get('https://djaura.pythonanywhere.com/ar/').then(res => {
            let items = res.data;
            let newState = [];
            for (let item in items) {
                var date =  items[item].article_date.split('T')[0]
                date = date.split('-')
                date = date[2]+' / '+date[1]+' / '+date[0]
                newState.push({
                    id: items[item].article_id,
                    author: items[item].article_author,
                    description: items[item].article_desc,
                    title: items[item].article_title,
                    date: date,
                    image: items[item].article_img
                });
            }
            this.setState({
                articles: newState,
            });
        });
        const { articles } = this.state;
        const pageLimit = 12
        const offset = (1 - 1) * pageLimit;
        const currentCountries = articles.slice(offset, offset + pageLimit);
        this.setState({ currentCountries });
        //features
        axios.get(`https://djaura.pythonanywhere.com/fa/`)
            .then(response => {
                
                let items = response.data;
                let newStates = [];
                response.data.article_desc.split('\n').map((item, i) => {
                    return newStates.push(item);
                });
                let image = 'https://djaura.pythonanywhere.com' + items.article_img
                var date =  items.article_date.split('T')[0]
                date = date.split('-')
                date = date[2]+' / '+date[1]+' / '+date[0]
                this.setState({
                    id: items.article_id,
                    author: items.article_author,
                    title: items.article_title,
                    date: date,
                    image,
                    article_desc: newStates,
                    loading: false
                });
            })
    }

    statechange = (id) => {
        this.props.getId(id)
    }

    onPageChanged = data => {
        const { articles } = this.state;
        const { currentPage, totalPages, pageLimit } = data;

        const offset = (currentPage - 1) * pageLimit;
        const currentCountries = articles.slice(offset, offset + pageLimit);

        this.setState({ currentPage, currentCountries, totalPages });
    }

    render() {
        const { classes } = this.props
        const { articles, loading, image, id, article_desc, author, date,title } = this.state
        // const random = Math.floor(Math.random() * articles.length)
        // Get current posts
        // const indexOfLastPost = currentPage * postsPerPage;
        // const indexOfFirstPost = indexOfLastPost - postsPerPage;
        // Change page
        // const paginate = pageNumber => this.setState({ currentPage: pageNumber });
        return (
            <div>
                <Helmet>
          <title>Writer's Niche || Aura</title>
          <meta
            name="description"
            content="Registration page for the auditions of the dramatics and film making team of DJ SAnghvi College of Engineering"
          />
        </Helmet>
                {loading ? <Loading/>  :
                <>
                <div className="jumbotron jumbotron-fluid fadeInUp" id='jumbotron' style={{ animationDelay: '0.5s' }}>
                    <div className="container">
                        <p className="disp">Writer’s Niche</p>
                        <p className="lead">The place where we showcase the talent of our brilliant writers.</p>
                    </div>
                </div>
                    <div>
                        <div className="jumbotron jumbotron-fluid fadeInUp" id='jumbotron' style={{ animationDelay: '0.6s' }}>
                            <Grid container spacing={0} className="center blogs">
                                <Grid item md={4} xs={12}>
                                    <div className="image">
                                        <img alt='masterpiece' src={image} style={{ width: '100%' }} />
                                    </div>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12} style={{ textAlign: 'left' }}>
                                            <p className="feature"><FontAwesomeIcon className="star" color="goldenrod" icon={faStar} />Masterpiece of the week</p>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography paragraph align="left" className="desc" >
                                                {article_desc.map((art,i) => {
                                                    return (
                                                        <Typography key={i} component={'span'} align="left">
                                                            {art.trim() !== 0 ? art : <br />}
                                                        </Typography>
                                                    )
                                                })}
                                            </Typography>
                                        </Grid>
                                        <Grid style={{ textAlign: 'left', marginLeft: '-1.2%', padding: '1%' }} item xs={12}>
                                            <Link to={`/blogs/${title.replace(/\s/g,'-').toLowerCase()}/${id}`} id="hover">
                                                <Button size="large" style={{ color: '#fffb', outline: 'none' }} onClick={() => { this.props.getId(id) }}>Read More</Button>
                                            </Link>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div className="blog-author2" style={{ textAlign: 'right' }}>
                                                <span>{author}</span>
                                                <span>|</span>
                                                <span>{date}</span>
                                            </div>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </div>

                        <Grid container spacing={0} className="outerCard center fadeInUp" style={{ animationDelay: '0.8s', justifyContent: 'center', maxWidth: '1300px', padding: '20px' }}>

                            {articles.map((write, index) => {
                                return (
                                    <Grid item xs={12} sm={6} md={4} className="innerCard" style={{ padding: '15px' }} key={index}>
                                        <Card id="cards" className="blog">
                                            <CardHeader className="headerss"
                                                avatar={
                                                    <Avatar aria-label="Recipe" className={classes.avatar}>
                                                        <img alt={write.title} src={icon} style={{ width: '100%' }} />
                                                    </Avatar>
                                                }
                                                title={write.author}
                                                subheader={write.date}
                                            />
                                            <CardMedia
                                                className={classes.media}
                                                image={write.image}
                                                title="Article Image"
                                            />
                                            <CardContent>
                                                <Link to={`blogs/${write.id}`} id="hover">
                                                    <h2 className="blog-title2">
                                                        {write.title}
                                                    </h2>
                                                </Link>
                                            </CardContent>
                                            <CardActions className={classes.actions} >
                                                <CopyToClipboard text={window.location.href + '/' + write.title.replace(/\s/g,'-').toLowerCase()+'/'+write.id}
                                                    onCopy={() => this.setState({ copied: true })}>
                                                    <IconButton aria-label="Share" style={{ outline: 'none' }}>
                                                        <ShareIcon />
                                                    </IconButton>
                                                </CopyToClipboard>
                                                <Link to={`blogs/${write.title.replace(/\s/g,'-').toLowerCase()}/${write.id}`} id="hover">
                                                    <Button size="small" id="read-more" color="primary" onClick={() => { this.props.getId(id)}}>
                                                        Read More
                                                    </Button>
                                                </Link>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </div>
                    </>}
            </div>
        )
    }
}

export default withStyles(styles)(WritersBlog)
